import { API_BASE_URL } from "@/lib/apiConfig";
import { getAccessToken } from "@/lib/authTokens";

const SESSION_KEY = "eusebionews-analytics-session";

function getSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}

function getUtmParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_campaign: params.get("utm_campaign") || "",
  };
}

function extractArticleSlug(pathname: string): string {
  const match = pathname.match(/^\/materia\/([^/]+)/);
  return match?.[1] || "";
}

export async function trackPageView(pathname: string, search = "") {
  const path = `${pathname}${search}` || "/";
  const payload = {
    path,
    article_slug: extractArticleSlug(pathname),
    referrer: document.referrer || "",
    session_id: getSessionId(),
    screen_width: window.screen?.width || 0,
    ...getUtmParams(),
  };

  const headers: Record<string, string> = { "Content-Type": "application/json" };
  const access = getAccessToken();
  if (access) {
    headers.Authorization = `Bearer ${access}`;
  }

  await fetch(`${API_BASE_URL}/track/`, {
    method: "POST",
    headers,
    body: JSON.stringify(payload),
    keepalive: true,
  });
}
